import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const yelp = defineConnector({
  identifier: "yelp",
  name: "Yelp",
  tagLine: "Local business search and reviews",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.yelp\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an app and API key",
      items: [
        {
          kind: "markdown",
          content:
            "Create an app in the [Yelp developer portal](https://www.yelp.com/developers/v3/manage_app) and copy its API key.",
        },
      ],
    },
    {
      title: "Paste your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.yelp.com/v3/categories",
  },
});
